import { Trascodifica } from "./trascodifica";

export class RichiestaMutuoRichiedenteImpegno {
  id: number;
  dataCreazione: Date;
  dataModifica: Date;
  istitutoErogante: String;
  durata: number;
  inizio: Date;
  residuo: number;
  rataMensile: number;
  idRichiedente: number;
  idTipologia: number;
  tipologia: Trascodifica;
  idPagReg: number;
  pagReg: Trascodifica;
  idEstinzione: number;
  estinzione: Trascodifica;
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/richiesta-mutuo-richiedente-impegno.ts